import React from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Products from "../components/Products";
import About from "../components/About";
import Inquiry from "../components/Inquiry";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-purple900">
      <Header />
      <Banner />
      <Products />
      <About />
      <Inquiry />
      <Footer />
    </main>
  );
} 